export function ascending(a: any, b: any): number {
    if (a < b)
        return -1;

    if (a > b)
        return 1;

    return 0;
}

export function descending(a: any, b: any) {
    if (a > b)
        return -1;

    if (a < b)
        return 1;

    return 0;
}

export default function<T>(source: T[], keySelector?: (source: T) => any, comparer = ascending): T[] {
    const array = [...source];

    array.sort((a, b) => {
        const aProp = keySelector ? keySelector(a) : a;
        const bProp = keySelector ? keySelector(b) : b;

        return comparer(aProp, bProp);
    });

    return array;
};